var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 80,
    viewBox: "0 0 60 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43693_18298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H34L60 26V72C60 76.4183 56.4183 80 52 80H8C3.58172 80 0 76.4183 0 72V8Z",
    fill: "url(#paint0_linear_43693_18298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 26H60L34 0V20C34 23.3137 36.6863 26 40 26Z",
    fill: "#DCE2EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 79H8C4.13401 79 1 75.866 1 72V8C1 4.13401 4.13401 1 8 1H33.5858L59 26.4142V72C59 75.866 55.866 79 52 79Z",
    stroke: "black",
    strokeOpacity: 0.06,
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8636 61.0753V60.858C28.8679 60.1122 28.9339 59.5178 29.0618 59.0746C29.1939 58.6314 29.3857 58.2734 29.6371 58.0007C29.8885 57.728 30.1911 57.4808 30.5447 57.2592C30.8089 57.0888 31.0455 56.9119 31.2543 56.7287C31.4631 56.5455 31.6293 56.343 31.7528 56.1214C31.8764 55.8956 31.9382 55.6442 31.9382 55.3672C31.9382 55.0732 31.8679 54.8153 31.7273 54.5938C31.5866 54.3722 31.397 54.2017 31.1584 54.0824C30.924 53.9631 30.6641 53.9034 30.3786 53.9034C30.1016 53.9034 29.8395 53.9652 29.5923 54.0888C29.3452 54.2081 29.1428 54.3871 28.9851 54.6257C28.8274 54.8601 28.7422 55.152 28.7294 55.5014H26.1214C26.1428 54.6491 26.3473 53.946 26.7351 53.392C27.1229 52.8338 27.6364 52.4183 28.2756 52.1456C28.9148 51.8686 29.62 51.7301 30.3913 51.7301C31.2393 51.7301 31.9893 51.8707 32.6413 52.152C33.2933 52.429 33.8047 52.8317 34.1754 53.3601C34.5462 53.8885 34.7315 54.5256 34.7315 55.2713C34.7315 55.7699 34.6484 56.2131 34.4822 56.6009C34.3203 56.9844 34.0923 57.3253 33.7983 57.6236C33.5043 57.9176 33.157 58.1839 32.7564 58.4226C32.4197 58.6229 32.1428 58.8317 31.9254 59.049C31.7124 59.2663 31.5526 59.5178 31.446 59.8033C31.3438 60.0888 31.2905 60.4403 31.2862 60.858V61.0753H28.8636ZM30.1293 65.1662C29.7031 65.1662 29.3388 65.017 29.0362 64.7188C28.7379 64.4162 28.5909 64.054 28.5952 63.6321C28.5909 63.2145 28.7379 62.8565 29.0362 62.5582C29.3388 62.2599 29.7031 62.1108 30.1293 62.1108C30.5341 62.1108 30.8899 62.2599 31.1967 62.5582C31.5036 62.8565 31.6591 63.2145 31.6634 63.6321C31.6591 63.9134 31.5845 64.1712 31.4396 64.4055C31.299 64.6357 31.1136 64.821 30.8835 64.9616C30.6534 65.098 30.402 65.1662 30.1293 65.1662Z",
    fill: "#344054"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43693_18298",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF1F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43693_18298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.d48c108343ded79f8609e48abe1e92df.svg";
export { ForwardRef as ReactComponent };